export default "__VITE_ASSET__ComgXwBv__"